import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"]
  static values = {
    copyLabel: String,
    copiedLabel: String,
  }

  disconnect() {
    if (this.feedbackTimeout) window.clearTimeout(this.feedbackTimeout)
  }

  async copy(event) {
    const source = this.hasSourceTarget ? this.sourceTarget : this.element.querySelector("[data-clipboard-text-target='source']")
    if (!source) return

    const trigger = event.currentTarget
    const text = source.value || source.textContent || ""
    const copied = await this.writeText(text)

    if (!copied) return

    if (trigger.dataset.clipboardTextNoFeedback === "true") return

    this.showFeedback(trigger)
  }

  async writeText(text) {
    if (window.navigator?.clipboard?.writeText) {
      try {
        await window.navigator.clipboard.writeText(text)
        return true
      } catch (_error) {
      }
    }

    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "-9999px"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    const copied = document.execCommand("copy")
    textarea.remove()
    return copied
  }

  showFeedback(trigger) {
    if (this.feedbackTimeout) window.clearTimeout(this.feedbackTimeout)

    const originalLabel = trigger.textContent
    const originalTitle = trigger.getAttribute("title")
    const originalAriaLabel = trigger.getAttribute("aria-label")
    const copiedLabel = this.copiedLabelValue || originalAriaLabel || originalTitle || originalLabel
    const copyLabel = this.copyLabelValue || originalLabel
    const copyIcon = trigger.querySelector("[data-clipboard-text-copy-icon]")
    const copiedIcon = trigger.querySelector("[data-clipboard-text-copied-icon]")
    const copiedClasses = (trigger.dataset.clipboardTextCopiedClass || "").split(/\s+/).filter(Boolean)

    if (copyIcon && copiedIcon) {
      copyIcon.classList.add("hidden")
      copiedIcon.classList.remove("hidden")
    } else {
      trigger.textContent = copiedLabel
    }

    copiedClasses.forEach((className) => trigger.classList.add(className))
    if (copiedLabel) {
      trigger.setAttribute("title", copiedLabel)
      trigger.setAttribute("aria-label", copiedLabel)
    }

    this.feedbackTimeout = window.setTimeout(() => {
      if (copyIcon && copiedIcon) {
        copiedIcon.classList.add("hidden")
        copyIcon.classList.remove("hidden")
      } else {
        trigger.textContent = copyLabel
      }

      copiedClasses.forEach((className) => trigger.classList.remove(className))
      if (originalTitle === null) {
        trigger.removeAttribute("title")
      } else {
        trigger.setAttribute("title", originalTitle)
      }

      if (originalAriaLabel === null) {
        trigger.removeAttribute("aria-label")
      } else {
        trigger.setAttribute("aria-label", originalAriaLabel)
      }
    }, 1500)
  }
}
